module.exports = __webpack_public_path__ + "images/PagerDuty-49b1d0.png";